import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { RegionModel } from '../AppGrid/RegionsTable';
import strings from '../Globalization';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';

const RegionGrid = RegionModel.createGridBase();
export const Region = () => {

	const [searchParam] = useSearchParams();
	const scopeModelId = searchParam.get('ScopeModelId');

	return (<CommonBreadCurmb
		actions={{ action: 'goback', route: '/scopeRegion' }}
		docTitle={strings.ScopeRegionConfiguration}
		breadcrumbs={[{ text: strings.ScopeRegionConfiguration }]}
		Component={RegionGrid}
		parentFilters={{ filter: [{ "operator": "$eq", "value": scopeModelId, "property": "ScopeModelId" }] }}
	/>)

}

